<template>
  <b-form
    id="form_feedback"
    ref="formFeedback"
    class="form form_feedback"
    :class="{ 'form-error': $v.$error }"
    novalidate
    @submit.prevent="someAction"
  >
    <div class="form__top-wrap">
      <div class="form__title">
        Связаться со&nbsp;службой поддержки
      </div>
    </div>
    <p>
      Кем вы являетесь?
    </p>
    <ul class="nav">
      <li>
        <button
          class="nav__item"
          :class="{ 'active': userSelected === USER.INDIVIDUAL_USER.value }"
          type="button"
          @click="userSelected = USER.INDIVIDUAL_USER.value"
        >
          {{ USER.INDIVIDUAL_USER.label }}
        </button>
      </li>
      <li>
        <button
          class="nav__item"
          :class="{ 'active': userSelected === USER.ONLINE_STORE_USER.value }"
          type="button"
          @click="userSelected = USER.ONLINE_STORE_USER.value"
        >
          {{ USER.ONLINE_STORE_USER.label }}
        </button>
      </li>
      <li>
        <button
          class="nav__item"
          :class="{ 'active': userSelected === USER.PICK_UP_POINT_USER.value }"
          type="button"
          @click="userSelected = USER.PICK_UP_POINT_USER.value"
        >
          {{ USER.PICK_UP_POINT_USER.label }}
        </button>
      </li>
    </ul>
    <div class="form__container flex-column align-items-start">
      <ul
        v-if="userSelected === USER.INDIVIDUAL_USER.value"
        class="form__fields"
      >
        <li class="form__field form__field_input">
          <div class="field-input">
            <InputTemplate
              v-model.trim="form.individualUser.name"
              :required="true"
              placeholder="Ваше имя"
              @blur="$v.form.individualUser.name.$touch()"
            />
            <svg
              class="name-icon"
              width="21px"
              height="21px"
            >
              <use xlink:href="#entity" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="$v.form.individualUser.name.$error && !form.individualUser.name.length"
            error-message="Обязательно для заполнения"
          />
          <ListErrorMessage
            v-else-if="$v.form.individualUser.name.$error && !$v.form.individualUser.name.validName"
            error-message="Только буквы"
          />
          <ListErrorMessage
            v-if="dataError"
            :error-message="dataError.name"
          />
        </li>
        <li class="form__field form__field_input">
          <div class="field-input">
            <InputEmail2
              v-model="form.individualUser.email"
              :required="true"
              placeholder="Email"
              @keyup-enter="submit"
              @blur="$v.form.individualUser.email.$touch()"
            />
            <svg
              class="mail-icon"
              width="21px"
              height="21px"
            >
              <use xlink:href="#mail" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="$v.form.individualUser.email.$error && !form.individualUser.email.length"
            error-message="Обязательно для заполнения"
          />
          <ListErrorMessage
            v-else-if="$v.form.individualUser.email.$error && !$v.form.individualUser.email.validateEmail"
            error-message="Введите e-mail в верном формате"
          />
          <ListErrorMessage
            v-if="dataError.email"
            :error-message="dataError.email"
          />
        </li>
        <li class="form__field form__field_input">
          <div class="field-input">
            <InputTemplate
              v-model="form.individualUser.departureNumber"
              placeholder="Номер отправления"
            />
          </div>
          <ListErrorMessage
            v-if="dataError"
            :error-message="dataError.departureNumber"
          />
        </li>

        <li class="form__field form__field_input">
          <div class="field-input">
            <SelectTemplate
              v-model="form.individualUser.topic"
              :options="topicPipOptions"
              placeholder="Тема обращения"
              @close="$v.form.individualUser.topic.$touch()"
            />
            <svg
              class="arrow-icon"
              width="24px"
              height="14px"
            >
              <use xlink:href="#arrow" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="$v.form.individualUser.topic.$error"
            error-message="Обязательно для заполнения"
          />
          <ListErrorMessage
            v-if="dataError"
            :error-message="dataError.trackNumber"
          />
        </li>


        <li class="form__field form__field_input">
          <div class="field-input">
            <TextareaTemplate
              v-model="$v.form.individualUser.question.$model"
              :placeholder="placeholderQuestionPip"
              @blur="$v.form.individualUser.question.$touch()"
            />
          </div>
          <ListErrorMessage
            v-if="$v.form.individualUser.question.$error"
            error-message="Обязательно для заполнения"
          />
          <ListErrorMessage
            v-if="dataError"
            :error-message="dataError.trackNumber"
          />
        </li>
        <li class="form__checkbox">
          <CheckboxSubscription
            @checkedSubscription="onCheckedSubscription"
          />
        </li>
        <li class="form__checkbox">
          <div class="field-checkbox field-checkbox_with-bg">
            <CheckboxAgreement
              link="/castnym-klientam/info-klientam/dokumenty"
              @updateChecked="checkboxStatus"
            />
          </div>
        </li>
        <li class="form__field form__field_input">
          <div class="field-input">
            <Recaptcha
              ref="recaptcha"
              :public-key="recaptchaKey"
              @verified="dataRecaptcha"
              @expired="removeDataRecaptcha"
            />
          </div>
        </li>
        <a
          class="form__button"
          :class="{'form__button_disabled': !buttonActive }"
          @click="submit"
        >{{ buttonText }}</a>
      </ul>
      <ul
        v-if="userSelected === USER.ONLINE_STORE_USER.value"
        class="form__fields"
      >
        <li class="form__field form__field_input">
          <div class="field-input">
            <InputTemplate
              v-model.trim="form.onlineStoreUser.name"
              :required="true"
              placeholder="Ваше имя"
              @blur="$v.form.onlineStoreUser.name.$touch()"
            />
            <svg
              class="name-icon"
              width="21px"
              height="21px"
            >
              <use xlink:href="#entity" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="$v.form.onlineStoreUser.name.$error && !form.onlineStoreUser.name.length"
            error-message="Обязательно для заполнения"
          />
          <ListErrorMessage
            v-else-if="$v.form.onlineStoreUser.name.$error && !$v.form.onlineStoreUser.name.validName"
            error-message="Только буквы"
          />
          <ListErrorMessage
            v-if="dataError"
            :error-message="dataError.name"
          />
        </li>
        <li class="form__field form__field_input">
          <div class="field-input">
            <InputEmail2
              v-model="form.onlineStoreUser.email"
              :required="true"
              placeholder="Email"
              @keyup-enter="submit"
              @blur="$v.form.onlineStoreUser.email.$touch()"
            />
            <svg
              class="mail-icon"
              width="21px"
              height="21px"
            >
              <use xlink:href="#mail" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="$v.form.onlineStoreUser.email.$error && !form.onlineStoreUser.email.length"
            error-message="Обязательно для заполнения"
          />
          <ListErrorMessage
            v-else-if="$v.form.onlineStoreUser.email.$error && !$v.form.onlineStoreUser.email.validateEmail"
            error-message="Введите e-mail в верном формате"
          />
          <ListErrorMessage
            v-if="dataError.email"
            :error-message="dataError.email"
          />
        </li>
        <li
          v-if="isContactSalesDepartmentTopicIm"
          class="form__field form__field_input">
          <div
            class="field-input"
          >
            <InputPhone
              v-model="form.onlineStoreUser.phone"
              :required="true"
              :dynamic-mask="true"
              :show-mask-on-focus="true"
              :show-mask-on-hover="true"
              placeholder="Номер телефона*"
              @keyup-enter="submit"
              @blur-phone="$v.form.onlineStoreUser.phone.$touch()"
              @change-phone="onEnteredPhone"
            />
            <svg
              class="phone-icon"
              width="21px"
              height="21px"
            >
              <use xlink:href="#phone-icon" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="$v.form.onlineStoreUser.phone.$error && !form.onlineStoreUser.phone"
            error-message="Обязательно для заполнения"
          />
          <ListErrorMessage
            v-else-if="!$v.form.onlineStoreUser.phone.validPhone && $v.form.onlineStoreUser.phone.$error"
            error-message="Заполните номер телефона"
          />
          <ListErrorMessage
            v-if="dataError"
            :error-message="dataError.phone"
          />
        </li>

        <li class="form__field form__field_input">
          <div class="field-input">
            <InputTemplate
              v-model.trim="form.onlineStoreUser.inn"
              placeholder="ИНН интернет-магазина"
              :required="true"
              @blur="$v.form.onlineStoreUser.inn.$touch()"
            />
          </div>
          <ListErrorMessage
            v-if="$v.form.onlineStoreUser.inn.$error && !form.onlineStoreUser.inn.length"
            error-message="Обязательно для заполнения"
          />
          <ListErrorMessage
            v-else-if="$v.form.onlineStoreUser.inn.$error"
            error-message="Введите ИНН в верном формате"
          />
          <ListErrorMessage
            v-if="dataError"
            :error-message="dataError.inn"
          />
        </li>

        <li
          v-if="isContactSalesDepartmentTopicIm"
          class="form__field form__field_input">
          <div class="field-input">
            <InputAddressSite
              :required="true"
              @blur="$v.form.onlineStoreUser.site.$touch()"
              @change-site="form.onlineStoreUser.site = $event"
            />
            <svg
              class="site-icon"
              width="24px"
              height="23px"
            >
              <use xlink:href="#site-icon" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="$v.form.onlineStoreUser.site.$error && !form.onlineStoreUser.site"
            error-message="Обязательно для заполнения"
          />
          <ListErrorMessage
            v-if="dataError"
            :error-message="dataError.site"
          />
        </li>

        <li
          v-if="isContactSalesDepartmentTopicIm"
          class="form__field form__field_input">
          <div class="field-input">
            <InputCitySuggest
              :required="true"
              :type-field="'select'"
              :selected-default-city="true"
              @change-city="(value) => onChangeCity(value, 'onlineStoreUser')"
              @change-city-default="(value) => onChangeCity(value, 'onlineStoreUser')"
              @keyup-enter="submit"
            />
            <svg
              class="arrow-icon"
              width="24px"
              height="14px"
            >
              <use xlink:href="#arrow" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="dataError"
            :error-message="dataError.cityName"
          />
        </li>

        <li class="form__field form__field_input">
          <div class="field-input">
            <SelectTemplate
              v-model="form.onlineStoreUser.topic"
              :options="topicImOptions"
              placeholder="Тема обращения"
              @close="$v.form.onlineStoreUser.topic.$touch()"
            />
            <svg
              class="arrow-icon"
              width="24px"
              height="14px"
            >
              <use xlink:href="#arrow" />
            </svg>
          </div>
          <ListErrorMessage
            v-if="$v.form.onlineStoreUser.topic.$error"
            error-message="Обязательно для заполнения"
          />
          <ListErrorMessage
            v-if="dataError"
            :error-message="dataError.trackNumber"
          />
        </li>

        <li class="form__field form__field_input">
          <div class="field-input">
            <TextareaTemplate
              v-model="$v.form.onlineStoreUser.question.$model"
              :placeholder="placeholderQuestionIm"
              @blur="$v.form.onlineStoreUser.question.$touch()"
            />
          </div>
          <ListErrorMessage
            v-if="$v.form.onlineStoreUser.question.$error"
            error-message="Обязательно для заполнения"
          />
          <ListErrorMessage
            v-if="dataError"
            :error-message="dataError.trackNumber"
          />
        </li>

        <li class="form__checkbox">
          <CheckboxSubscription
            @checkedSubscription="onCheckedSubscription"
          />
        </li>
        <li class="form__checkbox">
          <div class="field-checkbox field-checkbox_with-bg">
            <CheckboxAgreement
              link="/e-commerce/dokumenty/soglasenie-o-konfidencial-nosti-informacii-boksberri-soft"
              @updateChecked="checkboxStatus"
            />
          </div>
        </li>
        <li class="form__field form__field_input">
          <div class="field-input">
            <Recaptcha
              ref="recaptcha"
              :public-key="recaptchaKey"
              @verified="dataRecaptcha"
              @expired="removeDataRecaptcha"
            />
          </div>
        </li>
        <a
          class="form__button"
          :class="{'form__button_disabled': !buttonActive }"
          @click="submit"
        >{{ buttonText }}</a>
      </ul>
      <template v-if="userSelected === USER.PICK_UP_POINT_USER.value">
        <p class="mb-3 form__text">
          Хотите открыть отделение? Заполните форму в&nbsp;
          <a href="/biznes-partneram#bz">бизнес-разделе.</a>
        </p>
        <ul class="form__fields">
          <li class="form__field form__field_input">
            <div class="field-input">
              <InputTemplate
                v-model.trim="form.pickUpPointUser.name"
                :required="true"
                placeholder="Ваше имя"
                @blur="$v.form.pickUpPointUser.name.$touch()"
              />
              <svg
                class="name-icon"
                width="21px"
                height="21px"
              >
                <use xlink:href="#entity" />
              </svg>
            </div>
            <ListErrorMessage
              v-if="$v.form.pickUpPointUser.name.$error && !form.pickUpPointUser.name.length"
              error-message="Обязательно для заполнения"
            />
            <ListErrorMessage
              v-else-if="$v.form.pickUpPointUser.name.$error && !$v.form.pickUpPointUser.name.validName"
              error-message="Только буквы"
            />
            <ListErrorMessage
              v-if="dataError"
              :error-message="dataError.name"
            />
          </li>
          <li class="form__field form__field_input">
            <div class="field-input">
              <InputEmail2
                v-model="form.pickUpPointUser.email"
                :required="true"
                placeholder="Email"
                @keyup-enter="submit"
                @blur="$v.form.pickUpPointUser.email.$touch()"
              />
              <svg
                class="mail-icon"
                width="21px"
                height="21px"
              >
                <use xlink:href="#mail" />
              </svg>
            </div>
            <ListErrorMessage
              v-if="$v.form.pickUpPointUser.email.$error && !form.pickUpPointUser.email.length"
              error-message="Обязательно для заполнения"
            />
            <ListErrorMessage
              v-else-if="$v.form.pickUpPointUser.email.$error && !$v.form.pickUpPointUser.email.validateEmail"
              error-message="Введите e-mail в верном формате"
            />
            <ListErrorMessage
              v-if="dataError.email"
              :error-message="dataError.email"
            />
          </li>
          <li class="form__field form__field_input">
            <div class="field-input">
              <InputCitySuggest
                :required="true"
                :type-field="'select'"
                :selected-default-city="true"
                @change-city="(value) => onChangeCity(value, 'pickUpPointUser')"
                @change-city-default="(value) => onChangeCity(value, 'pickUpPointUser')"
                @keyup-enter="submit"
              />
              <svg
                class="arrow-icon"
                width="24px"
                height="14px"
              >
                <use xlink:href="#arrow" />
              </svg>
            </div>
            <ListErrorMessage
              v-if="dataError"
              :error-message="dataError.cityName"
            />
          </li>
          <li class="form__field form__field_input">
            <div class="field-input">
              <SelectTemplate
                v-model="form.pickUpPointUser.topic"
                :options="topicPpOptions"
                placeholder="Тема обращения"
                @close="$v.form.pickUpPointUser.topic.$touch()"
              />
              <svg
                class="arrow-icon"
                width="24px"
                height="14px"
              >
                <use xlink:href="#arrow" />
              </svg>
            </div>
            <ListErrorMessage
              v-if="$v.form.pickUpPointUser.topic.$error"
              error-message="Обязательно для заполнения"
            />

            <ListErrorMessage
              v-if="dataError"
              :error-message="dataError.trackNumber"
            />
          </li>


          <li class="form__field form__field_input">
            <div class="field-input">
              <TextareaTemplate
                v-model="$v.form.pickUpPointUser.question.$model"
                :placeholder="placeholderQuestionPp"
                @blur="$v.form.pickUpPointUser.question.$touch()"
              />
            </div>
            <ListErrorMessage
              v-if="$v.form.pickUpPointUser.question.$error"
              error-message="Обязательно для заполнения"
            />
            <ListErrorMessage
              v-if="dataError"
              :error-message="dataError.trackNumber"
            />
          </li>
          <li class="form__checkbox">
            <CheckboxSubscription
              @checkedSubscription="onCheckedSubscription"
            />
          </li>
          <li class="form__checkbox">
            <div class="field-checkbox field-checkbox_with-bg">
              <CheckboxAgreement
                link="/e-commerce/dokumenty/soglasenie-o-konfidencial-nosti-informacii-boksberri-soft"
                @updateChecked="checkboxStatus"
              />
            </div>
          </li>
          <li class="form__field form__field_input">
            <div class="field-input">
              <Recaptcha
                ref="recaptcha"
                :public-key="recaptchaKey"
                @verified="dataRecaptcha"
                @expired="removeDataRecaptcha"
              />
            </div>
          </li>
          <a
            class="form__button"
            :class="{'form__button_disabled': !buttonActive }"
            @click="submit"
          >{{ buttonText }}</a>
        </ul>
      </template>
    </div>
  </b-form>
</template>
<script>
import Vue from 'vue';
// eslint-disable-next-line
import Vuelidate from 'vuelidate';
import InputTemplate from '@/components/ComponentsForm/InputTemplate.vue';
import TextareaTemplate from '@/components/ComponentsForm/TextareaTemplate.vue';
import SelectTemplate from '@/components/ComponentsForm/SelectTemplate.vue';
import InputCitySuggest from '@/components/ComponentsForm/InputCitySuggest';
import InputEmail2 from '@/components/ComponentsForm/InputEmail2.vue';
import {
  email,
  required,
  numeric,
  minLength,
  maxLength,
} from 'vuelidate/lib/validators';
import CheckboxSubscription from '../ComponentsForm/CheckboxSubscription.vue';
import CheckboxAgreement from '../ComponentsForm/CheckboxAgreement.vue';
import ListErrorMessage from '../ComponentsForm/ListErrorMessage.vue';
import Recaptcha from '../ComponentsForm/Recaptcha.vue';
import formData from '../../helpers/form-data';
import InputPhone from '../ComponentsForm/InputPhone.vue';
import InputAddressSite from '../ComponentsForm/InputAddressSite.vue';

Vue.use(Vuelidate);

// eslint-disable-next-line
const axios = require('axios');

const TOPIC = {
  QUESTION_DELIVERY_GOODS_TOPIC: {
    label: 'Вопрос по доставке заказа',
    value: 'Question delivery goods',
  },
  FEEDBACK_OF_BOXBERRY_TOPIC: {
    label: 'Отзыв о работе с Boxberry',
    value: 'Feedback of Boxberry',
  },
  QUESTION_WORKING_WITH_BOXBERRY_TOPIC: {
    label: 'Вопрос по работе (я уже клиент Boxberry)',
    value: 'Question working with Boxberry',
  },
  SECURITY_SERVICE_TOPIC: {
    label: 'Служба безопасности',
    value: 'Security service',
  },
  CONTACT_SALES_DEPARTMENT_TOPIC: {
    label: 'Как начать работать с Boxberry?',
    value: 'Contact sales department',
  },
  INTERNATIONAL_DELIVERY_TOPIC: {
    label: 'Международная доставка',
    value: 'International delivery',
  },
};
const USER = {
  INDIVIDUAL_USER: {
    label: 'Частный клиент',
    value: 'Individual user',
  },
  ONLINE_STORE_USER: {
    label: 'Интернет-магазин',
    value: 'Online store user',
  },
  PICK_UP_POINT_USER: {
    label: 'Пункт выдачи',
    value: 'Pick up point user',
  },
};

export default {

  name: 'FormFeedback',
  components: {
    InputAddressSite,
    InputPhone,
    InputEmail2,
    InputCitySuggest,
    SelectTemplate,
    TextareaTemplate,
    InputTemplate,
    Recaptcha,
    CheckboxSubscription,
    CheckboxAgreement,
    ListErrorMessage,
  },
  props: {
    formType: {
      type: String,
      default: 'feedback',
    },
  },
  data() {
    return {
      validPhone: false,
      checkedCheckbox: false,
      recaptchaKey: window.recaptchaKey || null,
      cityKladr: '',
      region: '',
      citySuggest: '',
      valueName: '',
      valueEmail: null,
      valueSite: '',
      cityCode: '',
      cityName: '',
      valueSubscription: null,
      unmaskedPhone: null,
      dataCaptcha: '',
      valueOrganization: '',
      dataError: {
        email: null,
        phone: null,
      },
      validEmail: null,
      userSelected: USER.INDIVIDUAL_USER.value,
      topicSelected: '',
      topicPipOptions: [
        { name: TOPIC.QUESTION_DELIVERY_GOODS_TOPIC.label, value: TOPIC.QUESTION_DELIVERY_GOODS_TOPIC.value },
        { name: TOPIC.FEEDBACK_OF_BOXBERRY_TOPIC.label, value: TOPIC.FEEDBACK_OF_BOXBERRY_TOPIC.value },
        { name: TOPIC.SECURITY_SERVICE_TOPIC.label, value: TOPIC.SECURITY_SERVICE_TOPIC.value },
        { name: TOPIC.INTERNATIONAL_DELIVERY_TOPIC.label, value: TOPIC.INTERNATIONAL_DELIVERY_TOPIC.value },
      ],
      topicImOptions: [
        { name: TOPIC.QUESTION_WORKING_WITH_BOXBERRY_TOPIC.label, value: TOPIC.QUESTION_WORKING_WITH_BOXBERRY_TOPIC.value },
        { name: TOPIC.SECURITY_SERVICE_TOPIC.label, value: TOPIC.SECURITY_SERVICE_TOPIC.value },
        { name: TOPIC.CONTACT_SALES_DEPARTMENT_TOPIC.label, value: TOPIC.CONTACT_SALES_DEPARTMENT_TOPIC.value },
      ],
      topicPpOptions: [
        { name: TOPIC.SECURITY_SERVICE_TOPIC.label, value: TOPIC.SECURITY_SERVICE_TOPIC.value },
      ],
      form: {
        individualUser: {
          name: '',
          email: '',
          departureNumber: '',
          topic: null,
          question: '',
          errors: {},
        },
        onlineStoreUser: {
          name: '',
          email: '',
          city: '',
          citySuggest: '',
          inn: '',
          topic: null,
          question: '',
          phone: '',
          site: null,
          errors: {},
        },
        pickUpPointUser: {
          name: '',
          email: '',
          city: '',
          citySuggest: '',
          topic: null,
          question: '',
          errors: {},
        },
      },
      loading: false,
    };
  },
  computed: {
    buttonText() {
      return this.loading ? 'Подождите...' : 'Отправить заявку';
    },
    buttonActive() {
      return !this.loading;
    },
    placeholderQuestionPip() {
      return this.getPlaceholder(this.form.individualUser.topic && (this.form.individualUser.topic.value === TOPIC.SECURITY_SERVICE_TOPIC.value));
    },
    placeholderQuestionIm() {
      return this.getPlaceholder(this.form.onlineStoreUser.topic && (this.form.onlineStoreUser.topic.value === TOPIC.SECURITY_SERVICE_TOPIC.value));
    },
    placeholderQuestionPp() {
      return this.getPlaceholder(this.form.pickUpPointUser.topic && (this.form.pickUpPointUser.topic.value === TOPIC.SECURITY_SERVICE_TOPIC.value));
    },
    USER() {
      return ({ ...USER });
    },
    isContactSalesDepartmentTopicIm() {
      return this.form.onlineStoreUser.topic && this.form.onlineStoreUser.topic.value === TOPIC.CONTACT_SALES_DEPARTMENT_TOPIC.value;
    },
  },
  methods: {
    checkboxStatus(checked) {
      this.checkedCheckbox = checked;
    },
    onEnteredName(value) {
      this.valueName = value;
    },
    onEnteredEmail(value) {
      this.valueEmail = value;
    },
    onEnteredOrganization(value) {
      this.valueOrganization = value;
    },
    onEnteredSite(value) {
      this.valueSite = value;
    },
    onCheckedSubscription(value) {
      this.valueSubscription = value;
    },
    onChangeCity(value, inputName) {
      if (value) {
        this.form[inputName].city = value.Code;
        this.form[inputName].citySuggest = value.Name;
      } else {
        this.form[inputName].city = null;
        this.form[inputName].citySuggest = null;
      }
    },
    dataRecaptcha(value) {
      this.dataCaptcha = value;
    },
    removeDataRecaptcha() {
      this.dataCaptcha = '';
    },
    pushDataLayer() {
      // window.dataLayer = window.dataLayer || [];
      // window.dataLayer.push({
      //   event: 'main_ecomm_FORM_SENT_PM',
      // });
    },
    submit() {
      // if (ym) {
      //   ym(26117928, 'reachGoal', 'mimnew_start_lead');
      // }

      if (this.checkedCheckbox) {
        if (!this.isValidForm()) {
          return;
        }
        let dataFields;
        switch (this.userSelected) {
          case this.USER.INDIVIDUAL_USER.value:
            dataFields = {
              name: this.form.individualUser.name,
              email: this.form.individualUser.email,
              'departure-number': this.form.individualUser.departureNumber,
              topic: this.form.individualUser.topic.value,
              question: this.form.individualUser.question,
            };
            break;
          case this.USER.ONLINE_STORE_USER.value:
            dataFields = {
              name: this.form.onlineStoreUser.name,
              email: this.form.onlineStoreUser.email,
              inn: this.form.onlineStoreUser.inn,
              topic: this.form.onlineStoreUser.topic.value,
              question: this.form.onlineStoreUser.question,
            };
            break;
          case this.USER.PICK_UP_POINT_USER.value:
            dataFields = {
              name: this.form.pickUpPointUser.name,
              email: this.form.pickUpPointUser.email,
              city: this.form.pickUpPointUser.city,
              'city-suggest': this.form.pickUpPointUser.citySuggest,
              topic: this.form.pickUpPointUser.topic.value,
              question: this.form.pickUpPointUser.question,
            };
            break;
          default:
            break;
        }

        if (this.userSelected === this.USER.ONLINE_STORE_USER.value && this.isContactSalesDepartmentTopicIm) {
          dataFields.phone = this.form.onlineStoreUser.phone;
          dataFields.site = this.form.onlineStoreUser.site;
          dataFields.city = this.form.onlineStoreUser.city;
          dataFields['city-suggest'] = this.form.onlineStoreUser.citySuggest;
        }

        dataFields.agreement = this.checkedCheckbox;
        dataFields.captcha = this.dataCaptcha;
        dataFields.user = this.userSelected;

        this.loading = true;

        if (document.referrer) {
          dataFields.referer = document.referrer;
        }

        if (this.valueSubscription) {
          dataFields.subscription = this.valueSubscription;
        }

        const params = new URLSearchParams(window.location.search);
        params.forEach((value, key) => {
          dataFields[key] = value;
        });
        const url = (this.userSelected === this.USER.ONLINE_STORE_USER.value) ? '/form/support-legal' : '/form/support';

        axios({
          method: 'post',
          url,
          data: formData(dataFields),
        }).then((response) => {
          if (response.data.url) {
            // if (typeof ym !== 'undefined') {
            //   ym(57872296, 'reachGoal', 'mim_send_form');
            // }
            this.pushDataLayer();

            window.location = response.data.url;
          } else if (response.data.error) {
            this.dataError = response.data;
            if (response.data.messages) {
              const formErrorEvent = new CustomEvent('submit-error', { detail: { messages: response.data.messages } });
              document.dispatchEvent(formErrorEvent);
            }
          } else {
            const form = this.$refs.formFeedback;
            const detailObject = { form, response };
            const formSuccessEvent = new CustomEvent('submit-success', { detail: detailObject });
            document.dispatchEvent(formSuccessEvent);
            this.resetForm();

            // if (typeof ym !== 'undefined') {
            //   ym(57872296, 'reachGoal', 'mim_send_form');
            // }

            // this.pushDataLayer();
          }
        });

        this.loading = false;
        this.$refs.recaptcha.reset();
      }
    },
    getPlaceholder(selectSecurity) {
      return selectSecurity ? 'Сообщить о мошенничестве, нарушении прав' : 'Текст сообщения';
    },
    someAction() {
      this.$v.$touch();
    },
    isValidForm() {
      switch (this.userSelected) {
        case this.USER.INDIVIDUAL_USER.value:
          this.$v.form.individualUser.name.$touch();
          this.$v.form.individualUser.email.$touch();
          this.$v.form.individualUser.topic.$touch();
          this.$v.form.individualUser.question.$touch();
          return !this.$v.form.individualUser.name.$error
            && !this.$v.form.individualUser.email.$error
            && !this.$v.form.individualUser.topic.$error
            && !this.$v.form.individualUser.question.$error;
        case this.USER.ONLINE_STORE_USER.value:
          this.$v.form.onlineStoreUser.name.$touch();
          this.$v.form.onlineStoreUser.email.$touch();
          this.$v.form.onlineStoreUser.inn.$touch();
          this.$v.form.onlineStoreUser.topic.$touch();
          this.$v.form.onlineStoreUser.question.$touch();
          if (this.isContactSalesDepartmentTopicIm) {
            this.$v.form.onlineStoreUser.phone.$touch();
            this.$v.form.onlineStoreUser.site.$touch();
          }
          return !this.$v.form.onlineStoreUser.name.$error
            && !this.$v.form.onlineStoreUser.email.$error
            && !this.$v.form.onlineStoreUser.inn.$error
            && !this.$v.form.onlineStoreUser.topic.$error
            && !this.$v.form.onlineStoreUser.question.$error
            && (!this.isContactSalesDepartmentTopicIm
              || (!this.$v.form.onlineStoreUser.phone.$error
                && !this.$v.form.onlineStoreUser.site.$error)
            );
        case this.USER.PICK_UP_POINT_USER.value:
          this.$v.form.pickUpPointUser.name.$touch();
          this.$v.form.pickUpPointUser.email.$touch();
          this.$v.form.pickUpPointUser.topic.$touch();
          this.$v.form.pickUpPointUser.question.$touch();
          return !this.$v.form.pickUpPointUser.name.$error
            && !this.$v.form.pickUpPointUser.email.$error
            && !this.$v.form.pickUpPointUser.topic.$error
            && !this.$v.form.pickUpPointUser.question.$error;
        default:
          return false;
      }
    },
    resetForm() {
      let formKey;
      switch (this.userSelected) {
        case this.USER.INDIVIDUAL_USER.value:
          formKey = 'individualUser';
          break;
        case this.USER.ONLINE_STORE_USER.value:
          formKey = 'onlineStoreUser';
          break;
        case this.USER.PICK_UP_POINT_USER.value:
          formKey = 'pickUpPointUser';
          break;
        default:
          break;
      }

      Object.keys(this.form[formKey]).forEach((key) => {
        this.form[formKey][key] = '';
      });
      this.$v.form[formKey].$reset();
    },
    onEnteredPhone(value) {
      this.form.onlineStoreUser.phone = value.valuePhone;
    },
  },
  validations: {
    form: {
      individualUser: {
        name: {
          required,
          validName: (val) => /^\D+$/.test(val),
        },
        email: {
          required,
          validateEmail: email,
        },
        topic: {
          required,
        },
        question: {
          required,
        },
      },
      onlineStoreUser: {
        name: {
          required,
          validName: (val) => /^\D+$/.test(val),
        },
        email: {
          required,
          validateEmail: email,
        },
        inn: {
          required,
          numeric,
          minLength: minLength(10),
          maxLength: maxLength(12),
        },
        topic: {
          required,
        },
        question: {
          required,
        },
        phone: {
          required,
          validPhone: (val) => /^\+7\(\d\d\d\)\d\d\d-\d\d-\d\d$/.test(val),
        },
        site: {
          required,
        },
      },
      pickUpPointUser: {
        name: {
          required,
          validName: (val) => /^\D+$/.test(val),
        },
        email: {
          required,
          validateEmail: email,
        },
        topic: {
          required,
        },
        question: {
          required,
        },
      },
    },
  },
};
</script>
<style lang="scss">
@import 'FormFeedback.scss';
</style>
